<template>
  <div class="sale-requests">

    <div class="container-header">
      <div class="container-header__title">{{ i18n.sale_creation_requests() }}</div>
    </div>

    <div class="container container_40">
      <md-table class="scrollbar">

        <template v-if="salesList && list.length">
          <md-table-row class="sale-requests__row">
            <md-table-head>{{ i18n.lbl_sale_name() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_token_code() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_request_state() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_created_at() }}</md-table-head>
            <md-table-head>{{ i18n.lbl_updated_at() }}</md-table-head>
            <md-table-head><!--Button--></md-table-head>
          </md-table-row>
          <template v-for="(item, i) in list">

            <md-table-row class="sale-requests__row" @click="toggleDetails(i)" :key="i">
              <md-table-cell class="sale-requests__table-cell text_medium">{{ item.saleName }}</md-table-cell>
              <md-table-cell class="sale-requests__table-cell text_medium">{{ item.tokenCode }}</md-table-cell>
              <md-table-cell class="sale-requests__table-cell text_medium">{{ item.requestState }}</md-table-cell>
              <md-table-cell class="sale-requests__table-cell text_medium">{{ i18n.d(item.createdAt) }}</md-table-cell>
              <md-table-cell class="sale-requests__table-cell text_medium">{{ i18n.d(item.updatedAt) }}</md-table-cell>

              <md-table-cell class="sale-requests__table-cell">
                <md-button class="sale-requests__open-details-btn md-icon-button">
                  <md-icon v-if="isSelected(i)">keyboard_arrow_up</md-icon>
                  <md-icon v-else>keyboard_arrow_down</md-icon>
                </md-button>
              </md-table-cell>

            </md-table-row>

            <md-table-row class="sale-requests__expandable-row" v-if="isSelected(i)" :key="'selected-'+i">
              <md-table-cell colspan="7">
                <div class="md-layout">
                  <div v-if="item.saleLogoUrl" class="icon-column md-layout-item md-size-35 md-layout md-alignment-center-center">
                    <img class="token-icon" :src='item.saleLogoUrl' :alt="documentTypes.fundLogo">
                  </div>
                  <div class="details-column md-layout-item">
                    <detail prop="Request type" :value="`${ item.requestType }`"/>
                    <detail prop="Token name" :value="`${item.tokenCode}`"/>
                    <detail :prop="`${i18n.sale_start_time()}`" :value="`${i18n.d(item.startTime)}`"/>
                    <detail :prop="`${i18n.sale_close_time()}`" :value="`${i18n.d(item.endTime)}`"/>
                    <detail :prop="`${i18n.sale_soft_cap()}`" :value="`${i18n.c(item.softCap)} ${item.defaultQuoteAsset}`"/>
                    <detail :prop="`${i18n.sale_hard_cap()}`" :value="`${i18n.c(item.hardCap)} ${item.defaultQuoteAsset}`"/>
                    <detail :prop="`${i18n.sale_base_asset_hard_cap_to_sell({asset: item.tokenCode})}`" :value="`${i18n.c(item.baseAssetForHardCap)} ${item.tokenCode}`"/>
                    <detail :prop="`${i18n.sale_quote_assets()}`" :value="`${item.quoteAssets}`"/>
                    <detail :prop="`${i18n.sale_fund_video()}`" :value="item.youtubeVideoId ? `<a href='${item.youtubeVideoUrl}' target='_blank'>Open video</a>` : '-'"/>
                    <detail :prop="`${i18n.sale_short_description()}`" :value="`${item.shortDescription}`"/>
                    <detail :prop="`${i18n.lbl_reject_message()}`"
                            v-if="item.requestState === REQUEST_STATES_STR.rejected ||
                                item.requestState === REQUEST_STATES_STR.permanentlyRejected"
                            :value="`${item.rejectReason}`"/>
                  </div>
                </div>
                <md-card-actions>
                  <!-- <md-button class="md-dense md-accent"
                            :disabled="item.requestState !== REQUEST_STATES_STR.pending
                                    || isPending"
                            @click="cancelRequest(item.requestID)">{{ i18n.lbl_cancel() }}</md-button> -->
                  <template v-if="item.isApproved">
                    <md-button class="btn md-primary"
                               @click="goFundDetails(item.tokenCode)">
                      {{ i18n.lbl_view_sale() }}
                    </md-button>
                  </template>
                  <router-link :to="{name: 'sale-creation.index', params: { id: item.id }}"
                               tag="md-button"
                               class="btn md-primary"
                               :disabled="(!item.isPending && !item.isRejected) || isPending">{{ i18n.lbl_update() }}</router-link>
                </md-card-actions>
              </md-table-cell>
            </md-table-row>
          </template>
          <md-table-row v-if="!isLoaded">
            <md-table-cell colspan="7">
              <div class="tx-history__btn-outer">
                <md-button @click="more" :disabled="isLoading">{{ i18n.lbl_view_more() }}</md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </template>


        <template v-else>
          <div class="container__no-data">
            <md-icon class="md-size-4x">trending_up</md-icon>
            <div class="text_large">{{ i18n.sale_no_creation_requests() }}</div>
            <div class="text_description text_margin text_medium">{{ i18n.sale_no_creation_requests_desc() }}</div>
          </div>
        </template>
      </md-table>
    </div>
  </div>
</template>

<script>
import FormMixin from '@com/mixins/form.mixin'
import Detail from '@vue/app/common/Detail.Row'
import _get from 'lodash/get'

import { mapGetters, mapActions } from 'vuex'
import { i18n } from '@js/i18n'
import { REQUEST_STATES_STR, documentTypes, saleGetList } from '@const'
import { vuexTypes } from '@vuex/types'
import { vueRoutes } from '@router/const'
import { EventDispatcher } from '@js/events/event_dispatcher'

import { salesService } from '@api/sales.service'

export default {
  mixins: [FormMixin],
  components: { Detail },
  data: _ => ({
    i18n,
    salesList: null,
    isLoading: false,
    index: -1,
    documentTypes,
    REQUEST_STATES_STR,
    saleGetList
  }),

  async created () {
    this.salesList = saleGetList.saleList || null
    if (this.salesList) {
      await this.loadList(this.salesList)
    }
  },

  computed: {
    ...mapGetters([
      vuexTypes.saleCreationRequests
    ]),
    list () {
      return _get(this.saleCreationRequests, `${this.salesList}.records`, [])
    },
    isLoaded () {
      return _get(this.saleCreationRequests, `${this.salesList}.isLoaded`)
    }
  },

  methods: {
    ...mapActions({
      loadList: vuexTypes.GET_USER_SALE_CREATION_REQUESTS,
      loadNext: vuexTypes.NEXT_USER_SALE_CREATION_REQUESTS
    }),

    toggleDetails (index) {
      this.index = this.index === index ? -1 : index
    },

    isSelected (i) {
      return this.index === i
    },

    async more () {
      this.isLoading = true
      try {
        await this.loadNext(this.salesList)
      } catch (e) {
        console.error(e)
        EventDispatcher.dispatchShowErrorEvent(i18n.th_failed_to_load_tx())
      }
      this.isLoading = false
    },

    async goFundDetails (code) {
      const sale = await salesService.loadSaleByTokenCode(code)
      console.log('sale.id')
      console.log(sale.id)
      this.$router.push({
        ...vueRoutes.saleDetails,
        params: { id: sale.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .detail-row {
    white-space: normal;
  }

  .sale-requests {
    /*& /deep/ .md-content:not(.md-table-content) {
      margin-right: -8px;
    }
    & /deep/ .md-table-content {
      padding-right: 8px;
    }*/

    & .details-column {
      padding: 12px 46px 0 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/requests/index/Requests.SaleCreation.vue